define( [
	"./hasOwn"
], function( hasOwn ) {
	"use strict";

	return hasOwn.toString;
} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/var/fnToString.js
// module id = 175
// module chunks = 0